import {fabric} from 'fabric'

export function dynamic_curve(canvas, object) {
    canvas.on({
        'object:selected': onObjectSelected,
        'object:moving': onObjectMoving,
        'before:selection:cleared': onBeforeSelectionCleared
    });
    (function drawQuadratic() {

        var line = new fabric.Path(`${object?.line.path[0]} ${object?.line.path[1]}`, { fill: '', stroke: object?.line?.stroke, objectCaching: false,selectable:true, strokeDashArray: object?.line?.strokeDashArray, evented: false, id: object?.line?.id, name: 'line' });

          line.path[0][1] = object.p0.left;
          line.path[0][2] = object.p0.top;
          line.path[1][1] = object.p1.left;
          line.path[1][2] = object.p1.top;
          line.path[1][3] = object.p2.left;
          line.path[1][4] = object.p2.top;          

            updatePathBoundingBox(line);
            canvas.add(line);
            
            var p1 = makeCurvePoint(object.p1.left, object.p1.top, null, line, null, object.p1.id)
            p1.name = "p1";
            canvas.add(p1);
        
            var p0 = makeCurveCircle(object.p0.left, object.p0.top, line, p1, null, object.p0.id);
            p0.name = "p0";
            canvas.add(p0);
        
            var p2 = makeCurveCircle(object.p2.left, object.p2.top, null, p1, line, object.p1.id);
            p2.name = "p2";
            canvas.add(p2);

            canvas.remove(object?.line);
            canvas.remove(object?.p0);
            canvas.remove(object?.p1);
            canvas.remove(object?.p2);
  
    })();
    
    function updatePathBoundingBox(item) {
        var dims = item._calcDimensions()
        item.set({
          width: dims.width,
          height: dims.height,
          left: dims.left,
          top: dims.top,
          pathOffset: {
            x: dims.width / 2 + dims.left,
            y: dims.height / 2 + dims.top
          },
           dirty: false
        })
        item.setCoords()
      }
  
    function makeCurveCircle(left, top, line1, line2, line3, id) {
      var c = new fabric.Circle({
        left: left,
        top: top,
        strokeWidth: 2,
        radius: 4,
        fill: '#fff',
        stroke: '#666',
        originX: 'center',      
        originY: 'center',
        id: id
      });
  
      c.hasBorders = c.hasControls = false;
  
      c.line1 = line1;
      c.line2 = line2;
      c.line3 = line3;
  
      return c;
    }
  
    function makeCurvePoint(left, top, line1, line2, line3, id) {
      var c = new fabric.Circle({
        left: left,
        top: top,
        strokeWidth: 3,
        radius: 6,
        fill: '#fff',
        stroke: '#666',
        originX: 'center',      
        originY: 'center',
        selectable: true,
        id: id
      });
  
      c.hasBorders = c.hasControls = false;
  
      c.line1 = line1;
      c.line2 = line2;
      c.line3 = line3;
  
      return c;
    }
  
    function onObjectSelected(e) {
      var activeObject = e.target;
     
      if(e.target.type === 'path'){
        let n=0;
        canvas.getObjects().forEach((obj) => {
            if(obj.type === 'circle'){
                n++;
            }
        })
        if(n===0){
            let line = canvas.getActiveObject();
            var p1 = makeCurvePoint(line.path[1][1], line.path[1][2], null, line, null)
            p1.name = "p1";
            canvas.add(p1);
  
            var p0 = makeCurveCircle(line.path[0][1], line.path[0][2], line, p1, null);
            p0.name = "p0";
            canvas.add(p0);
  
            var p2 = makeCurveCircle(line.path[1][3], line.path[1][4], null, p1, line);
            p2.name = "p2";
            canvas.add(p2);
            canvas.renderAll();
            updatePathBoundingBox(line);
            return;
        }
        canvas.getObjects().forEach((obj) => {
            if(obj.type === 'circle'){
                canvas.remove(obj)
            }
            canvas.renderAll();
          });
      }
      if (activeObject.name === "p0" || activeObject.name === "p2") {
        activeObject.line2.animate('opacity', '1', {
          duration: 200,
          onChange: canvas.renderAll.bind(canvas),
        });
        activeObject.line2.selectable = true;
      }
    }
  
    function onBeforeSelectionCleared(e) {
      var activeObject = e.target;
      if (activeObject.name === "p0" || activeObject.name === "p2") {
        activeObject?.line2?.animate('opacity', '0', {
          duration: 200,
          onChange: canvas.renderAll.bind(canvas),
        });
        // activeObject.line2.selectable = false;
      }
      else if (activeObject.name === "p1") {
        activeObject.animate('opacity', '0', {
          duration: 200,
          onChange: canvas.renderAll.bind(canvas),
        });
        // activeObject.selectable = false;
      }
    }
  
    function onObjectMoving(e) {
      
      if (e.target.name === "p0" || e.target.name === "p2") {
        let p = e.target;
        
        if (p.line1) {
          p.line1.path[0][1] = p.left;
          p.line1.path[0][2] = p.top;
          updatePathBoundingBox(p.line1)
        }
        else if (p.line3) {
          p.line3.path[1][3] = p.left;
          p.line3.path[1][4] = p.top;
          updatePathBoundingBox(p.line3)
        }
      }
      else if (e.target.name === "p1") {
        let p = e.target;
  
        if (p.line2) {
          p.line2.path[1][1] = p.left;
          p.line2.path[1][2] = p.top;
          updatePathBoundingBox(p.line2)
        }
      }
      else if (e.target.name === "p0" || e.target.name === "p2") {
        let p = e.target;
  
        p.line1 && p.line1.set({ 'x2': p.left, 'y2': p.top });
        p.line2 && p.line2.set({ 'x1': p.left, 'y1': p.top });
        p.line3 && p.line3.set({ 'x1': p.left, 'y1': p.top });
        p.line4 && p.line4.set({ 'x1': p.left, 'y1': p.top });
      }
    }
  }